import Http from './../http';

const prefix = '/publication';



export const publish = id_website => Http.authApi().get(`${prefix}/${id_website}`);
export const updateVersion = id_website => Http.authApi().get(`${prefix}/version/${id_website}`);

export const publishWithoutDomain = id_website => Http.authApi().get(`${prefix}/without/${id_website}`);

export const publishWithoutDomainCaptcha = (idWebsite, captcha) => Http.authApi().post(`${prefix}/without/captcha/${idWebsite}`, {captcha: captcha});



// WEBPACK FOOTER //
// ./src/js/services/editor/publish.js